/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';
  app.Filters.SectionFilterView = app.BaseFilterView.extend({
    events: {
      'click .h3': 'toggleFilter',
      'click .tooltip a': function (e) {
        e.stopImmediatePropagation();
      }
    },
    additionalOptions: ['object', 'parent'],
    /**
     * Раскрытие/скрытие фильтров при клике на заголовок.
     * @param {Event} e
     */
    toggleFilter: function (e) {
      e.preventDefault();
      var className = this.object && this.object.class_name;
      var canFoldFilter = className !== 'Specification' && !app.isMobile;
      if (canFoldFilter && !(app.features && app.features.is_new_filters_appearance)) {
        var $parent = $(e.currentTarget).parent(),
          id = $parent.attr('id'),
          wrapped_filters = localStorage.wrapped_filters ? JSON.parse(localStorage.getItem('wrapped_filters')) : {};
        if (this.$('.section-inside').hasClass('not_display')) {
          wrapped_filters[id] = true;
          localStorage.setItem('wrapped_filters', JSON.stringify(wrapped_filters));
        } else {
          wrapped_filters[id] = false;
          localStorage.setItem('wrapped_filters', JSON.stringify(wrapped_filters));
        }
        $parent.toggleClass('wrapped');
        this.$('.section-inside').toggleClass('not_display');
        this.$('.section-arrow').toggleClass('arrow_up');
        this.$('.side-filter-controls').toggleClass('not_display');
        this.$('.filter-search').toggleClass('not_display');
        this.$('.js-toggle').toggleClass('not_display');
        app.EventBus.trigger('filter.section.toggle.view', e);
      }
    },

    /**
     * Проверка на совпадение присутствующих фильтров.
     * @param {Array} externalValues Внешние данные поля фильтрации.
     * @returns {boolean} Признак присутствия внешних данных в данных фильтра.
     */
    isValuesIntersect: function (externalValues) {
      var valuesIds = _.map(this.object.values, 'id');
      return Array.isArray(externalValues) && Boolean(_.intersection(valuesIds, externalValues).length);
    },

    /**
     * Вывод выбранных фильтров на первые позиции в списке.
     */
    sortSelectedFilters: function (simpleSortSelected) {
      var selectedFilters = app.helpers.UrlHelper.getUrlParameter('f') || '';
      var selector = '';
      var ids = [];
      var filterPageFilters = this.object.filterPageFilters;

      if (selectedFilters.length) {
        try {
          selectedFilters = JSON.parse(selectedFilters);
        } catch (e) {
          selectedFilters = {};
        }
      }
      if (filterPageFilters) {
        selectedFilters = _.merge(filterPageFilters, selectedFilters);
      }
      if (simpleSortSelected) {
        selector = 'input:checked';
      } else {
        if (selectedFilters[this.name] && this.isValuesIntersect(selectedFilters[this.name])) {
          _.each(selectedFilters[this.name], function (filter) {
            if (this.object.data_type === 'numrange') {
              filter = String(filter).replace(/\D+/g, '');
            }
            ids.push('#' + this.name + '-' + filter);
          }.bind(this));
        } else if (this.object.sub_filters) {
          _.each(_.keys(this.object.sub_filters), function (key) {
            if (selectedFilters[key]) {
              ids.push('#markers_filter-' + key);
            }
          });
        }
      }
      selector = ids.length ? ids.join() : selector;
      var checkedFilters = this.$(selector).parent();
      if (checkedFilters.length) {
        checkedFilters.parent().prepend(checkedFilters);
      }

      // убираем заголовки у трейдмарок, если после сортировки они опустели
      var trademarkHeaders =  this.$('.trademark-header');
      if (
        _.some(trademarkHeaders, function (trademarkHeader) {
          return !$(trademarkHeader).next('.label').length;
        })
      ) {
        $(trademarkHeaders).remove();
      }
      this.wrapFilters();
    },
    /**
     * Оборачивание фильтров, если их больше заданного числа.
     * Метод для переопределения в потомках
     */
    wrapFilters: function () {},
  });
})();


}.call(window));